export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11261.19e5b5ea.jpg";